// action types
export const LOAD = "LOAD";
export const CHECK_CODE = "CHECK_CODE";

// mutation types
export const RECEIVE = "RECEIVE";
export const RECEIVE_DISCOUNT = "RECEIVE_DISCOUNT";
export const SET_STATUS = "SET_STATUS";